/* src/app/modules/shared/components/header-column/header-column-appearance/header-column-appearance.component.scss */
app-header-column-appearance {
  display: contents;
}
/*# sourceMappingURL=header-column-appearance.component.css.map */
